import React, { Component, useState } from "react";
import { connect } from "react-redux";
import { changeLanguageAction, reset, logout } from "./action";
import "./header.css";
import { Icon, Dropdown, Menu, Spin, Col, Affix, Modal, Badge } from "antd";
import { DownOutlined, SettingOutlined } from "@ant-design/icons";
import i18next from "i18next";
import { version } from "../../../package.json";

import { Logo, UserLogo } from "./style";
import logo from "../../Assets/img/logo_square.png";
import defaultUser from "../../Assets/img/default-user.png";
import indonesiaFlag from "../../Assets/img/indonesia.png";
import ukFlag from "../../Assets/img/uk.png";
import { themeColor } from "../../Config/Constant";
import { destroySession } from "../../Helper/general";

import { Link, withRouter } from "react-router-dom";
import NotificationMenu from "../NotificationList";
import { useNotificationsClaimPending } from "../../Hook/hookNotifClaim";
const confirm = Modal.confirm;

const NotificationBellDropdown = ({ claimPending }) => {
  const [visible, setVisible] = useState(false);
  const { badgeCount, refetchNotifications } = useNotificationsClaimPending();

  const handleVisibleChange = (flag) => {
    setVisible(flag);
    if (flag && typeof refetchNotifications === "function") {
      refetchNotifications();
    }
  };

  const count =
    badgeCount !== undefined && badgeCount !== null
      ? badgeCount
      : (claimPending &&
          !claimPending.error &&
          claimPending.finish &&
          (Array.isArray(claimPending.data?.data)
            ? claimPending.data.data.length
            : Array.isArray(claimPending.data?.data?.data)
            ? claimPending.data.data.data.length
            : 0)) ||
        0;

  return (
    <Dropdown
      overlay={
        <NotificationMenu
          dataClaimPending={claimPending}
          onItemClick={() => setVisible(false)}
        />
      }
      trigger={["click"]}
      visible={visible}
      onVisibleChange={handleVisibleChange}
    >
      <Badge count={count}>
        <Icon
          type="bell"
          style={{
            fontSize: 20,
            color: "#fff",
            cursor: "pointer",
          }}
        />
      </Badge>
    </Dropdown>
  );
};

class Headers extends Component {
  state = {
    isChangePassword: false,
    hasNewClaim: true,
    visible: false,
  };

  handleIsChangePassword = () => {
    this.setState({
      isChangePassword: true,
    });
  };

  handleClick = () => {
    this.props.reset();
  };

  logout = (val) => {
    this.props.logout(val);
  };

  Modal_Logout = () => {
    let { lang } = this.props;
    i18next.init({
      lng: lang,
      resources: {
        en: {
          translation: {
            logout: "Logout",
            logoutDesc: "Are you sure want to logout? ",
          },
        },
        id: {
          translation: {
            logout: "Keluar",
            logoutDesc: "Apakah anda yakin ingin keluar dari aplikasi? ",
          },
        },
      },
    });

    const modal = confirm({
      title: i18next.t("logout"),
      content: i18next.t("logoutDesc"),
      onOk: async () => {
        const { dataUser } = this.props;
        modal.destroy();
        await destroySession({ dataUser });
      },
      onCancel() {
        modal.destroy();
      },
    });
  };

  handleLang = (evt) => {
    this.props.changeLang(evt.target.alt);
  };

  handleVisibleChange = (flag) => {
    this.setState({
      visible: flag,
    });
  };
  render() {
    let { dataUser, lang, error2fa, isLogin, claimPending } = this.props;

    i18next.init({
      lng: lang,
      resources: {
        en: {
          translation: {
            home: "Home",
            transactionReport: "Transaction report",
            icdCode: "ICD Code",
            reprint: "Reprint",
            verifyUser: "Verify user",
            changePassword: " Change password",
            verifyMember: "Verify member",
            logout: "Logout",
            "Upload doc": "Document Upload",
            biometricEnroll: "Biometric Enrollment",
            fingerprintEnroll: "Fingerprint Enrollment",
            faceEnroll: "Face Recognition Enrollment",
            createinvoice: "Invoice",
            changeUsername: " Change username",
            userMgt: "User Management",
            Form: "Form",
          },
        },
        id: {
          translation: {
            home: "Beranda",
            transactionReport: "Laporan Transaksi",
            icdCode: "Kode ICD",
            reprint: "Cetak Ulang",
            verifyUser: "Verifikasi Pengguna",
            changePassword: " Ubah kata sandi",
            verifyMember: "Verifikasi member",
            logout: "Keluar",
            "Upload doc": "Unggah Dokumen",
            biometricEnroll: "Pendaftaran Biometrik",
            fingerprintEnroll: "Pendaftaran Sidik Jari",
            createinvoice: "Tagihan",
            changeUsername: " Ubah nama pengguna",
            userMgt: " User Management",
            Form: "Formulir",
          },
        },
      },
    });

    const menu = (
      <Menu style={{ marginTop: 25 }}>
        {dataUser && dataUser.active_flag ? (
          <Menu.Item key="1" onClick={this.handleIsChangePassword}>
            <Link to="/user-management">
              <SettingOutlined />
              {i18next.t("userMgt")}
            </Link>
          </Menu.Item>
        ) : null}
        <Menu.Divider />
        <Menu.Item key="2" onClick={this.handleIsChangePassword}>
          <Link to="/changeUsername">
            <Icon type="user" />
            {i18next.t("changeUsername")}
          </Link>
        </Menu.Item>
        <Menu.Item key="3" onClick={this.handleIsChangePassword}>
          <Link to="/changePassword">
            <Icon type="lock" />
            {i18next.t("changePassword")}
          </Link>
        </Menu.Item>
        <Menu.Divider />
        <Menu.Item key="4" onClick={this.Modal_Logout}>
          <Icon type="logout" style={{ color: "red" }} />
          {i18next.t("logout")}
        </Menu.Item>
      </Menu>
    );

    const menuBio = (
      <Menu style={{ marginTop: 25 }}>
        <Menu.Item key="1">
          <Link to="/fingerprintRegister">
            {i18next.t("fingerprintEnroll")}
          </Link>
        </Menu.Item>
        <Menu.Item key="2">
          <Link to="/faceRecognitionRegister">{i18next.t("faceEnroll")}</Link>
        </Menu.Item>
      </Menu>
    );

    return !isLogin ? null : (
      <div
        style={{
          backgroundColor: "#fff",
          marginBottom: 40,
          height: 100,
        }}
      >
        <div
          style={{
            backgroundColor: themeColor,
            display: "flex",
            alignItems: "center",
            flexWrap: "nowrap",
          }}
        >
          <Col span={6} style={{ paddingLeft: 10 }}>
            <a href="/">
              <Logo src={logo} />
            </a>
          </Col>

          <div className="main-lang">
            <div
              className="users"
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                gap: 15,
              }}
            >
              <NotificationBellDropdown claimPending={claimPending} />
              <Dropdown overlay={menu} trigger={["click"]}>
                <span
                  className="ant-dropdown-link"
                  style={{ cursor: "pointer" }}
                >
                  <UserLogo src={defaultUser} />
                </span>
              </Dropdown>
              <div style={{ color: "#fff", fontSize: "0.9rem" }}>
                Hi,
                {dataUser ? (
                  dataUser.first_name + "  " + dataUser.last_name
                ) : (
                  <Spin size="small" />
                )}
              </div>
            </div>
          </div>
        </div>
        <Affix offsetTop={0}>
          <div className="main-menu">
            <div className="sub-menu">
              <div
                style={{
                  position: "absolute",
                  marginTop: 25,
                  left: 0,
                  color: "#919191",
                }}
              >
                {version}
              </div>
              {this.props.location.pathname === "/changePassword" ||
              this.props.location.pathname === "/changeUsername" ? (
                <Menu
                  onClick={this.handleClick}
                  selectedKeys={[this.props.location.pathname]}
                  mode="horizontal"
                  style={{
                    backgroundColor: "#f2f2f2",
                  }}
                >
                  <Menu.Item key="/" style={{ marginLeft: "17%" }}>
                    <Link to="/">
                      <Icon type="home" />
                    </Link>
                  </Menu.Item>
                  <Menu.Item key="/changePassword">
                    <Link to="/changePassword">
                      {i18next.t("changePassword")}
                    </Link>
                  </Menu.Item>
                  <Menu.Item key="/changeUsername">
                    <Link to="/changeUsername">
                      {i18next.t("changeUsername")}
                    </Link>
                  </Menu.Item>
                </Menu>
              ) : (
                <Menu
                  onClick={this.handleClick}
                  selectedKeys={[this.props.location.pathname]}
                  mode="horizontal"
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    backgroundColor: "#f2f2f2",
                    width: "100%",
                  }}
                >
                  <Menu.Item key="/">
                    <Link to="/">
                      <Icon type="home" />
                      {i18next.t("home")}
                    </Link>
                  </Menu.Item>
                  <Menu.Item key="/transactionReport">
                    <Link to="/transactionReport">
                      <Icon type="file-text" />
                      {i18next.t("transactionReport")}
                    </Link>
                  </Menu.Item>
                  <Menu.Item key="/icd">
                    <Link to="/icd">
                      <Icon type="database" />
                      {i18next.t("icdCode")}
                    </Link>
                  </Menu.Item>
                  <Menu.Item key="/reprint">
                    <Link to="/reprint">
                      <Icon type="printer" />
                      {i18next.t("reprint")}
                    </Link>
                  </Menu.Item>
                  <Menu.Item key="/form">
                    <Link to="/form">
                      <Icon type="form" />
                      {i18next.t("Form")}
                    </Link>
                  </Menu.Item>
                  <Menu.Item key="/Upload">
                    <Link to="/Upload">
                      <Icon type="upload" />
                      {i18next.t("Upload doc")}
                    </Link>
                  </Menu.Item>

                  {dataUser && dataUser.is_biometric_show ? (
                    <Menu.Item>
                      <Dropdown overlay={menuBio} key="menubio">
                        <span
                          className="ant-dropdown-link"
                          onClick={(e) => e.preventDefault()}
                        >
                          <Icon type="user-add" />
                          {i18next.t("biometricEnroll")} <DownOutlined />
                        </span>
                      </Dropdown>
                    </Menu.Item>
                  ) : null}
                </Menu>
              )}
            </div>
            <div className="slct-lang">
              <img
                alt="id"
                src={indonesiaFlag}
                onClick={this.handleLang}
              />

              <img
                alt="en"
                src={ukFlag}
                onClick={this.handleLang}
              />
            </div>
          </div>
        </Affix>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    data2fa: state.verifyOtp.data,
    isFetching2fa: state.verifyOtp.isFetching,
    isLogout: state.verifyOtp.isLogout,
    error2fa: state.verifyOtp.error,
    dataUser: state.verifyOtp.data,
    lang: state.changeLang.lang,
    isLogin: state.isLogin.isLogin,
    claimPending: state.claimListPending,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    changeLang: (data) => dispatch(changeLanguageAction(data)),
    reset: () => dispatch(reset()),
    logout: (data) => dispatch(logout(data)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withRouter(Headers));
